import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';
import DrawerFormSkeleton from 'components/shared/CRUD/components/DrawerFormSkeleton';

import { HolidaySpecialForm } from '../HolidaySpecialForm';
import { useGetClaData } from '../hooks/useGetClaData';
import useGetHolidaysSpecialRowData from '../hooks/useGetHolidaysSpecial';

const CreateEditForm = ({ rowId, handleClose }: FormComponentProps) => {
  const { data: holidaysSpecial = [], isFetching } =
    useGetHolidaysSpecialRowData();
  const { data: claData, isFetching: isClaFetching } = useGetClaData();

  return isFetching || isClaFetching ? (
    <DrawerFormSkeleton count={1} />
  ) : (
    <HolidaySpecialForm
      data={holidaysSpecial?.find(
        ({ holidaySpecialId }) => holidaySpecialId === rowId
      )}
      claData={claData ?? []}
      handleClose={handleClose}
    />
  );
};

export default CreateEditForm;
